import { RootAppState } from 'store/configureStore'

export const projectEstimatedDeliveryDaysSelector = (state: RootAppState) =>
  state.project.activeProject?.deliveryEstimation
